<script>
  import { onMount } from 'svelte';
  import { KEYCODES } from './constants.ts';
  
  let { container = null } = $props();

  onMount(() => {
    const element = container || document.body;

    const autoFocus = (event) => {
      const isTabPressed = event.keyCode === KEYCODES.TAB;
      if (!isTabPressed) {
        return;
      }

      const focusableEls = Array.from(
        element.querySelectorAll(
          'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), .allow-tab'
        )
      );

      const firstFocusableEl = focusableEls[0];
      const lastFocusableEl = focusableEls[focusableEls.length - 1];

      // If shift + tab is clicked on first element
      // Focus to last focusable element
      //
      // Else if tab is clicked on last element
      // Focus to first focusable element
      if (event.shiftKey) {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          event.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          event.preventDefault();
        }
      }
    };

    element.addEventListener('keydown', autoFocus);

    return () => {
      element.removeEventListener('keydown', autoFocus);
    };
  });
</script>
